import styled from 'styled-components';

export const Container = styled.div`
  padding: 32px 16px;
`;
export const SettingsTopbar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
export const BackIcon = styled.img`
  margin-left: 26px;
  margin-right: 10px;
  cursor: pointer;
`;

export const SettingsIconBlock = styled.div`
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #6f85ff 0%, #9c58ff 100%);
  box-shadow:
    0px 4px 6px -4px #0000001a,
    0px 10px 15px -3px #0000001a;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const SettingsImg = styled.img``;
export const SettingsTitleBlock = styled.div``;
export const SettingsTitle = styled.h3`
  font-weight: 700;
  font-size: 30px;
  letter-spacing: 0.4px;
  color: #212529;
  margin-bottom: 6px;
  &.confirmation {
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    color: #212529;
    margin-top: 20px;
  }
  &.date-title {
    margin-top: 0;
    margin-bottom: 25px;
  }
`;
export const SettingsSubTitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: #4a5565;
  &.confirmation-sub {
    color: #6c757d;
    text-align: center;
  }
`;
export const AssignmentCard = styled.div`
  background: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: 8px;
  margin-top: 32px;
  overflow: hidden;
  position: relative;
`;
export const InfoGroupLabel = styled.label`
  color: #000;
`;
export const InfoGroupSpan = styled.span`
  color: #6c757d;
`;
export const InfoGroupText = styled.p`
  max-width: 300px;
  color: #6c757d;
`;

export const CardHeader = styled.div`
  padding: 16px 32px;
  display: flex;
  gap: 10px 32px;
  flex-wrap: wrap;
  &.card-header {
    border-bottom: 1px solid #e5e7eb;
  }
`;

export const InfoGroup = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;

  &.upcoming-img {
    align-items: center;
  }
`;

export const StatusBadge = styled.span`
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  background-color: ${(props) => (props.$type === 'active' ? '#15C7A710' : '#D4D8DD')};
  color: ${(props) => (props.$type === 'active' ? '#15C7A7' : '#fff')};
  &.action-type {
    background-color: #2d6cdf1a;
    color: #2d6cdf;
  }
`;

export const EditImg = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 20px;
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    opacity: 0.7;
  }
`;

export const LoadContainer = styled.div`
  width: 100%;
  min-height: 500px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoadingIcon = styled.img`
  animation: rotate 1s linear infinite;
  width: 100px;

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
export const UpcomingImg = styled.img``;
export const SearchAndFilter = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 32px;
  flex-wrap: wrap;

  & > div {
    margin-bottom: 0;
    > div {
      min-width: 138px;
      max-width: max-content;
    }
  }
  .react-select__clear-indicator {
    cursor: pointer;
    color: #999;
    padding: 0 6px;
  }
`;
export const FormWrapper = styled.div`
  &.date-effective {
    > div {
      min-height: auto;
      > div {
        min-height: auto;
      }
    }
    .css-g8sef0-MuiInputBase-root-MuiOutlinedInput-root {
      height: 44px;
      margin-bottom: 4px;
    }
    legend {
      display: none;
    }
  }
`;
export const ButtonWrapper = styled.div`
  display: flex;
  gap: 25px;
  justify-content: center;
  margin-top: 40px;
  .cancel {
    border: 1px solid #d4d8dd;
    width: 184px;
    font-weight: 600;
    font-size: 16px;
    color: #0a0a0a;
    height: 44px;
  }
  .confirm {
    background: linear-gradient(90deg, #2969c9 0%, #265ba8 100%);
    font-weight: 700;
    font-size: 16px;
    color: #ffffff;
    width: 184px;
  }
`;
export const CheckBg = styled.div`
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: linear-gradient(135deg, #d0fae5 0%, #cbfbf1 100%);
  box-shadow:
    0px 3.1px 4.65px -3.1px #0000001a,
    0px 7.75px 11.63px -2.32px #0000001a;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;
export const AlertIcon = styled.img``;
export const ErrorDate = styled.p`
  color: #e63946;
  font-weight: 600;
  font-size: 12px;
  margin: 0;
  line-height: 1;
  text-align: right;
`;
export const UserColor = styled.div`
  color: #2d6cdf;
  text-decoration: underline;
  cursor: pointer;
`;
export const DeleteActionIcon = styled.img`
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    opacity: 0.3;
    cursor: not-allowed;
    pointer-events: none;
  `}
`;
